export class DatatableColumnsConstants {
    public static readonly selectedColumns = `_datatable_selected_columns`;
    public static readonly selectedAttributeValuesColumns = `add_edit_product_attribute_values`;
    public static readonly selectedAttributeValuesContractDurationColumns = `add_edit_product_attribute_values_contract_duration`;
    public static readonly selectedAttributeValuesBillingCycleColumns = `add_edit_product_attribute_values_billing_cycle`;
    public static readonly orderByAttributeValues = 'add_edit_product_attribute_values_order_by';
    public static readonly hideColumnSearchFunctionality = '_hide_column_search_functionality';
}
